import Header from "@/components/layout/Header";
import PageHeaderTitle from "@/components/layout/PageHeaderText";
import PageLayout from "@/components/layout/PageLayout";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import SpotPositionsMarqueeHeader from "../-components/SpotPositionsMarqueeHeader";
import PumpHeader from "./-components/PumpHeader";
import PumpTables from "./-components/PumpTables";
import Providers from "./-providers";
import PumpPageErrorHandler from "./-components/PumpPageErrorHandler";

const schema = z.object({
  error: z.string().optional(),
});

export const Route = createFileRoute("/_main/atoms/")({
  head: () => ({
    meta: [{ title: "Reactor | Atoms" }],
  }),
  validateSearch: (search) => schema.parse(search),
  component: AtomsPage,
});

function AtomsPage() {
  return (
    <PumpPageErrorHandler>
      <PageLayout
        header={
          <>
            <PageHeaderTitle title="Reactor Atoms" />
            <SpotPositionsMarqueeHeader />
            <Header />
          </>
        }
      >
        <Providers>
          <div className="flex h-full w-full flex-col gap-1.5 overflow-hidden">
            <div className="flex w-full flex-1 flex-col gap-1.5 overflow-hidden">
              <PumpHeader />
              <PumpTables />
            </div>
          </div>
        </Providers>
      </PageLayout>
    </PumpPageErrorHandler>
  );
}
